module.exports = __webpack_public_path__ + "img/icon_recently.2701f4f2.svg";